import React from "react"
import { P } from "@cd2/text"
import { useConfirmation } from "./useConfirmation"
import { ConfirmCancelDialogue } from "../Components/ConfirmCancelDialogue"
import { useSkeemFetch2 } from "../Pages/CustomerArea/CustomerHome"

export function useBlockUserToggle() {
  return useConfirmation<
    { contact: { name: string }; block?: boolean; shouldAddRole?: boolean },
    boolean
  >(({ data, onResolve }) => {
    const title = data.block
      ? `Are you sure you want to block ${data.contact.name}`
      : `Unblock ${data.contact.name}`
    const body = data.block ? (
      <P>
        By blocking {data.contact.name}, you will prevent them from logging in to their account.
        <br></br>
        {data.shouldAddRole && <P>The user will automatically be assigned to the 'blocked' role.</P>}
      </P>
    ) : (
      <P>
        By unblocking {data.contact.name}, you will allow them to resume logging in to their
        account.
      </P>
    )
    return (
      <ConfirmCancelDialogue
        heading={title}
        onConfirm={() => onResolve(true)}
        onCancel={() => onResolve(false)}
        body={
          <React.Fragment>
            {body}
            <P weight={600}>Are you sure you want to proceed?</P>
          </React.Fragment>
        }
        isOpen
      ></ConfirmCancelDialogue>
    )
  })
}
